import React from 'react'
import Link from "gatsby-link"
import Bus from '../utils/bus'
let BUS = new Bus()

class Intro extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //
  }

  render() {
    const { copy } = this.props.data;
    return (
      <div
        className="Problem Purpose"
        id="mission"
        ref={el => {
          this.el = el;
        }}
      >
        <div className="internal">
          <span className="ww-icon">➁</span>
          <div className="copy" dangerouslySetInnerHTML={{ __html: copy }} />
        </div>
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/home/purpose.js